import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { Voucher } from '@photobooth/types';

export function useVouchers(params?: { isActive?: boolean; search?: string }) {
  const [vouchers, setVouchers] = useState<Voucher[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchVouchers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.vouchers.getAll(params);
      if (response.success && response.data) {
        setVouchers(Array.isArray(response.data) ? response.data : []);
      } else {
        setError('Failed to fetch vouchers');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch vouchers');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVouchers();
  }, [params?.isActive, params?.search]);

  return {
    vouchers,
    isLoading,
    error,
    refetch: fetchVouchers,
  };
}
